export const RECEIVE_BULK_UPLOAD_DIFFS = 'RECEIVE_TEAM_BULK_UPLOAD_DIFFS';
export const RECEIVE_CARD_STATEMENT_UPLOAD_DIFFS = 'RECEIVE_CARD_STATEMENT_UPLOAD_DIFFS';
export const REVIEW_CARD_HOLDERS = 'REVIEW_CARD_HOLDERS';
export const REVIEW_DUPLICATES = 'REVIEW_DUPLICATES';
export const TOGGLE_CHANGE_TO_APPLY = 'TOGGLE_CHANGE_TO_APPLY';
export const TOGGLE_VIEWING_ERROR_DETAILS = 'TOGGLE_VIEWING_ERROR_DETAILS';
export const RECORD_PROCESSING_FAILURE = 'RECORD_PROCESSING_FAILURE';
export const CLEAR_PROCESSING_FAILURE = 'CLEAR_PROCESSING_FAILURE';
export const TOGGLE_CONFIRMING_CHANGES = 'TOGGLE_CONFIRMING_CHANGES';
export const SET_PREVIEW_TAB = 'SET_PREVIEW_TAB';
export const SAVE_CSV_DATA = 'SAVE_CSV_DATA';
export const SET_DIFFS_TO_APPLY = 'SET_DIFFS_TO_APPLY'; // a little odd, we'll use this to skip the other diffs
export const UPDATE_ADD_CARD_DIFF_CARD_HOLDER = 'UPDATE_ADD_CARD_DIFF_CARD_HOLDER';
export class ClearProcessingFailure {
    constructor() {
        this.type = CLEAR_PROCESSING_FAILURE;
    }
}
export class ReceiveBulkUploadDiffs {
    constructor(diffs) {
        this.diffs = diffs;
        this.type = RECEIVE_BULK_UPLOAD_DIFFS;
    }
}
export class ReceiveCardStatementUploadDiffs {
    constructor(diffs) {
        this.diffs = diffs;
        this.type = RECEIVE_CARD_STATEMENT_UPLOAD_DIFFS;
    }
}
export class ReviewCardHolders {
    constructor(reviewed) {
        this.reviewed = reviewed;
        this.type = REVIEW_CARD_HOLDERS;
    }
}
export class ReviewDuplicates {
    constructor(reviewed) {
        this.reviewed = reviewed;
        this.type = REVIEW_DUPLICATES;
    }
}
export class UpdateAddCardDiffCardHolder {
    constructor(temporaryAccountId, userId) {
        this.temporaryAccountId = temporaryAccountId;
        this.userId = userId;
        this.type = UPDATE_ADD_CARD_DIFF_CARD_HOLDER;
    }
}
export class SetDiffsToApply {
    constructor(diffs) {
        this.diffs = diffs;
        this.type = SET_DIFFS_TO_APPLY;
    }
}
export class RecordProcessingFailure {
    constructor(error, diffs) {
        this.error = error;
        this.diffs = diffs;
        this.type = RECORD_PROCESSING_FAILURE;
    }
}
export class SaveCsvData {
    constructor(data, fileType) {
        this.data = data;
        this.fileType = fileType;
        this.type = SAVE_CSV_DATA;
    }
}
export class SetPreviewTab {
    constructor(change) {
        this.change = change;
        this.type = SET_PREVIEW_TAB;
    }
}
export class ToggleChangeToApply {
    constructor(change) {
        this.change = change;
        this.type = TOGGLE_CHANGE_TO_APPLY;
    }
}
export class ToggleConfirmingChanges {
    constructor() {
        this.type = TOGGLE_CONFIRMING_CHANGES;
    }
}
export class ToggleViewingErrorDetails {
    constructor() {
        this.type = TOGGLE_VIEWING_ERROR_DETAILS;
    }
}
